import adminApi from '../../components/apis/adminApi';

export async function refreshSchedules() {
  return adminApi.get('/api/admin/schedules/refresh').then((res) => res.data);
}

export async function refreshCoreAuth() {
  return adminApi.get('/api/admin/core/refresh').then((res) => res.data);
}

export async function refreshStations(id, values) {
  return adminApi.get('/api/admin/stations/refresh', values).then((res) => res.data);
}
